<div class="app-header">
  <div class="banner">
    <div
      [ngStyle]="{'background-image':'url(' + banner_image + ')'}"
      class="banner__bg"
    >
      <div class="banner__content">
        <h2 class="banner__content__pretitle">{{'Statistics' | transloco}}</h2>
        <h1 class="banner__content__title">{{ title }}</h1>
      </div>
    </div>
  </div>
</div>
<div class="app-content">
  <router-outlet></router-outlet>
</div>
